export const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = '';
};